"use client";

import { useQuery } from "@tanstack/react-query";

import { getInsuranceCard } from "@/src/requests/insurance-card";

export const INSURANCE_CARD_CACHE_KEY = "insurance-card";

export function useInsuranceCard(patientId: string | null, coverageId: string | null, departmentId?: string | null) {
  const query = useQuery({
    queryKey: [INSURANCE_CARD_CACHE_KEY, patientId, coverageId, departmentId ?? null],
    queryFn: () => getInsuranceCard(patientId!, coverageId!, departmentId),
    enabled: Boolean(patientId && coverageId),
    staleTime: 5 * 60 * 1000,
  });

  return query.data ?? null;
}
